$ = require 'jquery'
TrelloClipboard = require 'app/scripts/lib/trello-clipboard'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
log = require 'app/scripts/debug/log'
{ getTypes, getPasted } = require 'app/scripts/views/internal/data-transfer/normalize'
triggerList = require 'app/scripts/lib/util/event/trigger-list'

module.exports = PasteInput = new class
  constructor: ->
    @_handlers = {}

    $(document).on 'paste', @paste
    TrelloClipboard.on 'pasteImage', (image) =>
      @triggerPasted('files', [image])

  precedence:
    list: 4
    card: 5
    dialog: 10

  addHandler: (target, { scope, precedence }) ->
    precedence ?= @precedence[scope]
    if !precedence?
      log('pasteinput', "Missing precedence for #{ scope }")
      precedence = @precedence.default

    @_handlers[scope] ?= {}
    @_handlers[scope] = {
      target
      scope
      precedence
    }

    log('pasteinput', "Adding handler for #{ scope }")

  removeHandler: (target) ->
    for scope, { target: hTarget } of @_handlers when target == hTarget
      log('pasteinput', "Removing handler for #{ scope }")
      delete @_handlers[scope]

  _sortedHandlers: ->
    _.sortBy(_.values(@_handlers), (h) -> -h.precedence)

  paste: (e) =>
    getPasted(e.originalEvent).then (pasted) =>
      if _.isEmpty(pasted)
        return

      if (pasted.text || pasted.url) && e.target.tagName in ['INPUT', 'TEXTAREA']
        # If they're pasting text into an input of some kind, just let the
        # default handling happen … unless it's the trello clipboard trying to
        # intercept the paste, in which case it's okay to handle it
        if !TrelloClipboard.isClipboard(e.target)
          return

      # Some applications (like PowerPoint and OneNote) will put several
      # different types on the clipboard when you copy. If there is some text,
      # assume they want that (and not a picture of the text).
      for type in ['url', 'text', 'files'] when pasted[type]
        @triggerPasted(type, pasted[type])
        break

      return

    return

  triggerPasted: (type, detail) ->
    elements = _.compact(@_sortedHandlers().map (handler) -> handler.target?.el)
    triggerList elements, "pasteinput:#{ type }", { detail }
